import React from "react";
import { Modal } from "@mui/material";
import Styles from "./TenderResult.module.css";
import { Close } from "@mui/icons-material";

const TenderResult = ({ open, handleClose, data }) => {
  const renderHeader = () => {
    const headerText = "Tender Result";
    return (
      <div className={`display_flex_row modalHeading ${Styles.headingText}`}>
        <div className={`headingText ${Styles.finalHead}`}>{headerText}</div>
        <Close
          style={{ fontSize: "24px", color: "#777777", cursor: "pointer" }}
          onClick={handleClose}
        />
      </div>
    );
  };
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <div className={`popupModal ${Styles.tenderResultContainer}`}>
        {renderHeader()}
        Under Development
      </div>
    </Modal>
  );
};

export default TenderResult;
